// extracted by mini-css-extract-plugin
module.exports = {"BudgetForm":"BudgetForm_BudgetForm__28SJY","Error":"BudgetForm_Error__1p8RQ"};